export default () => {
  return new Date().toISOString();
};
